<template>
  <div id="folder-add-or-update-dialog" class="custom-modal">
    <div class="modal-body">
      <transition name="el-fade-in" mode="out-in">
        <HolaconLottie  v-if="loading == 'updateScreenLoading' && form == null" key="create-loading"  />
        <el-row v-else key="content-loading">
          <el-row :gutter="10">
            <el-col :span="24" class="mt-3">
              <div class="registerform-input-container">
                <div class="custom-label">
                  <label>{{ $t("contentManagement.files.fileCategoryAddUpdate.title") }}</label>
                  <el-tooltip placement="top">
                    <div slot="content" class="custom-tooltip-content"><span>{{ $t("contentManagement.files.fileCategoryAddUpdate.titleMsg") }}</span></div>
                    <i class="el-icon-info"></i>
                  </el-tooltip>
                </div>
                <el-input v-model="form.title" :class="$inputError('title', validationErrors)"></el-input>
                <span class="error">{{ $errorMessage('title', validationErrors) }}</span>
              </div>
            </el-col>
            <el-col :span="24" class="mt-3">
              <div class="registerform-input-container">
                <div class="custom-label">
                  <label>{{ $t("contentManagement.files.fileCategoryAddUpdate.color") }}</label>
                  <el-tooltip placement="top">
                    <div slot="content" class="custom-tooltip-content"><span>{{ $t("contentManagement.files.fileCategoryAddUpdate.colorMsg") }}</span></div>
                    <i class="el-icon-info"></i>
                  </el-tooltip>
                </div>
                <el-color-picker v-model="form.color" :class="$inputError('color', validationErrors)"></el-color-picker>
                <span class="error">{{ $errorMessage('color', validationErrors) }}</span>
              </div>
            </el-col>
          </el-row>

          <el-row :gutter="10">
            <el-col class="mt-2" :span="24">
              <div class="custom-section-container">
                <div class="section-header" @click="settingsDock = !settingsDock">
                  <div class="section-title">
                    <div class="section-head">
                      <label>{{ $t("contentManagement.files.fileCategoryAddUpdate.settings") }}</label>
                      <!-- <el-tooltip content="Content" placement="bottom">
                          <i class="el-icon-info"></i>
                        </el-tooltip> -->
                    </div>
                    <span>{{ $t("contentManagement.files.fileCategoryAddUpdate.settingsMsg") }}</span>
                  </div>
                  <div class="section-accordion">
                    <i class="fa" :class="settingsDock ? 'fa-angle-up' : 'fa-angle-down'"></i>
                  </div>
                </div>
                
                <transition name="el-zoom-in-top">
                  <div class="section-wrapper" v-show="settingsDock">
                    <div class="custom-set-container" :class="form.isActive ? 'sactive' : 'spassive'">
                      <div class="custom-set-inner">
                        <i class="fa" :class="form.isActive ? 'fa-eye' : 'fa-eye-slash'"></i>
                        <div class="custom-set-info">
                          <label>{{ $t("contentManagement.files.fileCategoryAddUpdate.view") }}
                            <!-- <el-tooltip content="Content" placement="bottom">
                              <i class="el-icon-info"></i>
                            </el-tooltip> -->
                          </label>
                          <span>{{ $t("contentManagement.files.fileCategoryAddUpdate.viewMsg") }}</span>
                        </div>
                      </div>
                      <div class="custom-set-actions fend">
                        <el-switch v-model="form.isActive"></el-switch>
                      </div>
                    </div>

                    <div class="custom-set-container" :class="form.enableCustomTags ? 'sactive' : ''">
                      <div class="custom-set-inner">
                        <i class="fa" :class="form.enableCustomTags ? 'fa-tags' : 'fa-tags'"></i>
                        <div class="custom-set-info">
                          <label>
                            {{ $t("contentManagement.files.fileCategoryAddUpdate.useTags") }}
                            <!-- <el-tooltip content="Content" placement="bottom">
                              <i class="el-icon-info"></i>
                            </el-tooltip> -->
                          </label>
                          <span>{{ $t("contentManagement.files.fileCategoryAddUpdate.useTagsMsg") }}</span>
                        </div>
                      </div>
                      <div class="custom-set-actions fend">
                        <el-switch v-model="form.enableCustomTags"></el-switch>
                      </div>
                      <div class="custom-set-actions fcenter mt-3" v-show="form.enableCustomTags">
                        <CustomTag :value="form.customTags" :key="form.id" v-model="form.customTags"></CustomTag>
                      </div>
                    </div>
                  </div>
                </transition>
              </div>
            </el-col>
          </el-row>
        </el-row>
      </transition>
    </div>
    <div class="modal-footer" slot="footer" v-if="loading != 'updateScreenLoading' && form != null">
      <div class="left-buttons">
        <el-button @click="$emit('closeDialog')">{{ $t("contentManagement.files.fileCategoryAddUpdate.close") }}</el-button>
        <template v-if="form.id != null">
          <el-popconfirm @confirm="deleteItem" :confirmButtonText="$t('event.variables.yes')" :cancelButtonText="$t('event.buttons.cancel')" icon="el-icon-info" iconColor="red" :title="$t('event.textbox.toDelete')">
            <el-button slot="reference" type="danger" icon="fas fa-trash"> {{ $t("contentManagement.files.fileCategoryAddUpdate.delete") }}</el-button>
          </el-popconfirm>
        </template>
      </div>
      <div class="right-buttons">
        <el-button type="primary" :loading="loading == 'saveLoading'" :disabled="loading == 'saveLoading'" @click="save">{{ $t("contentManagement.files.fileCategoryAddUpdate.save") }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios';
  import ItemInfo from './ItemInfo';
  export default {
    components: { ItemInfo },
    name: 'DocumentCategoryAddUpdate',
    props: ['id'],
    data() {
      return {
        settingsDock: false,
        form: null,
        logoPercent: 0,
        axios,
        validationErrors: [],
        showInfo: false,
        loading: false,
        timeout: null,
      };
    },
    methods: {
      deleteItem() {
        this.$emit('deleteMeCategory', this.form.id);

        this.$emit('closeDialog');
      },
      save() {
        this.loading = 'saveLoading';
        if (this.timeout != null) clearTimeout(this.timeout);
        this.timeout = setTimeout(async () => {
          var res = await this.$store.dispatch('documentCategoryAddUpdate', this.form);
          this.validationErrors = res.data.validationErrors;
          if (!res.data.alert.hasError) {
            this.form = res.data.data.item;
            await this.$store.dispatch('getDocumentCategoryList');
          }
          this.loading = false;
        }, 500);
        // axios
        //   .post('document/categoryaddorupdate', {
        //     ...this.form,
        //     categoryID: this.categoryId,
        //   })
        //   .then((res) => {
        //     this.validationErrors = res.data.validationErrors;
        //     if (res.data.alert.hasError) {
        //       this.$message.error(res.data.alert.message);
        //     } else {
        //       this.$message.success(res.data.alert.message);
        //       if (this.form.id == null) {
        //         this.$emit('itemAdded', res.data.data);
        //         this.form = {
        //           id: null,
        //           title: null,
        //           orderNO: 99,
        //           logoScale: 25,
        //           isActive: true,
        //         };
        //       } else {
        //         this.$emit('itemUpdated', JSON.parse(JSON.stringify(this.form)));
        //         if (this.showInfo) {
        //           this.showInfo = false;
        //           setTimeout(() => {
        //             this.showInfo = true;
        //           }, 350);
        //         }
        //       }
        //     }
        //   });
      },
      logoProgress(event) {
        this.logoPercent = event.percent;
      },
      logoSuccess(response) {
        this.logoPercent = 0;
        if (response.alert.hasError) {
          this.$message.error(response.alert.message);
        } else {
          this.$message.success(response.alert.message);
          this.form.image = response.data;
        }
      },
    },
    async created() {
      this.loading = 'updateScreenLoading';
      if (this.timeout != null) clearTimeout(this.timeout);

      if (this.id != undefined && this.id != null) {
        this.timeout = setTimeout(async () => {
          var res = await this.$store.dispatch('getDocument', this.id);
          if (!res.data.alert.hasError) {
            this.form = res.data.data.item;
          } else {
            this.$emit('closeMe');
          }
          this.loading = false;
        }, 500);
      } else {
        this.timeout = setTimeout(() => {
          this.form = {
            id: null,
            title: null,
            isActive: false,
            color: null,
            enableCustomTags: false,
            customTags: [],
          };
          this.loading = false;
        }, 500);
      }
    },
  };
</script>

<style lang="less">
  #sponsor-add-new-update {
    padding: 1rem;
  }
  .registerform-input-container {
    .tag-container {
      gap: 1rem;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
    }
    .badge-list {
      display: flex;
      flex-direction: row;
      gap: 1rem;
      .badger {
        border-radius: 8px;
        background-color: #f3f3f3;
        height: 20px;
        padding: 10px;
      }
    }
    .title {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 0.5rem;
      label {
        font-weight: bold;
        color: black;
        margin-bottom: 0;
      }
      .title-container {
        display: flex;
        flex-direction: row;
        gap: 1rem;
        align-items: center;
      }
    }
    display: flex;
    flex-direction: column;
    .el-input-number {
      width: 100%;
    }
  }
  .mage-maker {
    width: 100%;
    position: relative;
    border: 1px dashed #ccc;
    height: 250px;
    background-size: contain !important;
    background-position: center center !important;
    border-radius: 5px;
    background-repeat: no-repeat !important;
    .avatar-uploader {
      opacity: 0;
      transition: all 1s;
      &:hover {
        opacity: 1 !important;
      }
      & > .el-upload {
        background-color: rgba(0, 0, 0, 0.5);
        width: 100%;
        height: 250px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/FileCategoryAddUpdate.vue